import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Form } from 'antd'

import PopupModal from 'Shared/Components/PopupModal'
import { Dropdown, FormContainer, TextInput } from 'Shared/Components/FormComponents'
import useCommonAPI from 'Shared/API/Common'
import { showSuccess } from 'Shared/Components/NotifyToast'
import { useOutletContext } from 'react-router-dom'
import useSmartwatchAPI from 'Shared/API/Smartwatch'

const AddDeviceFormContent = ({ onFinish }) => {
  const { setPageLoading } = useOutletContext()
  
  const { t } = useTranslation()
  
  const [form] = Form.useForm()

  const { getWorkers } = useCommonAPI()

  const [workers, setWorkers] = useState([])

  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      const w = await getWorkers()
      setWorkers(w["data"])

      setPageLoading(false)
    }

    init()
  }, [])

  return (
    <FormContainer form={form} onFinish={onFinish}>
      <TextInput field_name={t("smartwatch_deviceId")} field_id="device_id" />
      <Dropdown field_name={t("smartwatch_worker")} field_id="worker_id" props={{ "options": workers.map((i) => ({ "value": i["worker_id"], "label": i["worker_name"] })) }}/>
    </FormContainer>
  )
}

const AddDeviceForm = ({ isOpen, device_type, loadData, onClose }) => {
  const { setPageLoading } = useOutletContext()

  const { t } = useTranslation()

  const { addDevice } = useSmartwatchAPI()

  const onFinish = async (values) => {    
    setPageLoading(true)

    const res = await addDevice({device_type: device_type, device_id: values["device_id"], worker_id: values["worker_id"]})

    if (res != null) {
      onClose()
      showSuccess(t("general_success"))

      loadData()
    }

    setPageLoading(false)
  }

  return (
    <PopupModal isOpen={isOpen} close toggle={() => onClose()} width="80%">
      <AddDeviceFormContent onFinish={onFinish} />
    </PopupModal>
  )
}

export default AddDeviceForm
